import type { ReactNode } from 'react';
import { Loader2 } from 'lucide-react';

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  type = 'button',
  disabled,
  loading = false,
  onClick,
  className = '',
  title,
  ariaLabel,
}: {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost' | 'link' | 'success';
  size?: 'sm' | 'md' | 'lg';
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  /** Inline spinner for submit/mutation actions (does not block the page). */
  loading?: boolean;
  onClick?: () => void;
  className?: string;
  title?: string;
  ariaLabel?: string;
}) {
  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      title={title}
      aria-label={ariaLabel}
      aria-busy={loading || undefined}
      className={`btn btn-${variant}${size !== 'md' ? ` btn-${size}` : ''} ${className}`.trim()}
    >
      {loading ? <Loader2 size={16} className="btn-spinner" aria-hidden /> : null}
      {children}
    </button>
  );
}
